import logo from './logo.svg';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/Auth";
import Login from './Pages/Login'
import Veilleur from './Pages/Veilleur/Veilleurview'

import './App.css';



function App() {

  
  return (

    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />

            <Route path="/Login" element={<Login />} />
            <Route path="/Veilleur" element={<Veilleur />} />




 </Routes>
        </div>
      </Router>
    </AuthProvider>







  );





}

export default App;
